import BottomSheetContent from '../../../../../../../components/BottomSheetComponents/BottomSheetContent'
import { ALLOCATION_PLANS_THEME } from '../../../../lumpsum/plans-list/header/common/riskProfileHeaderTheme'
import { PlanEducationIcon } from '../../../../lumpsum/plans-list/timer/shared/planEducationIcons'
import { SIP_YOUR_PLAN_FEATURE_ROWS } from '../../timer/shared/sipYourPlanFeatureRows'

type SipYourPlanInfoBottomSheetProps = {
  onDismiss: () => void
}

export function SipYourPlanInfoBottomSheet({ onDismiss }: SipYourPlanInfoBottomSheetProps) {
  return (
    <BottomSheetContent
      heading="SIP Plan"
      onDismiss={onDismiss}
      bottomSheetHeadClassName="!pt-6"
      bottomSheetHeadingClassName="!text-[22px] !text-[#232323] !leading-[130%] !font-[500] !mb-0"
      bottomSheetBodyClassName="!pt-2 !pb-6"
    >
      <div className="text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
        <p>
          Know which SIPs to start, increase, decrease or stop so your portfolio's allocation stays on the right track.
        </p>
        <div className="flex flex-col gap-6 pt-6">
          {SIP_YOUR_PLAN_FEATURE_ROWS.map((featureRow) => (
            <div key={featureRow.title} className="flex items-center gap-4">
              <PlanEducationIcon
                iconId={featureRow.iconId}
                color={ALLOCATION_PLANS_THEME.primary}
                className="-mt-[5px] size-6 shrink-0"
              />
              <p className="text-[14px] leading-[150%]">
                <span className="font-[500] text-[#232323]">{featureRow.title}</span>{' '}
                <span className="text-[#6A6E6E]">{featureRow.caption}</span>
              </p>
            </div>
          ))}
        </div>
      </div>
    </BottomSheetContent>
  )
}
